const LINKS = {
    'social_media_twitter': "http://twitter.com/infinityb",
    'blog_brendan_gregg': 'http://www.brendangregg.com/blog/index.html',
    'youtube_semiconductors_magic': 'https://www.youtube.com/watch?v=NGFhc8R_uO4',
    'youtube_bcantrill_oral_history': 'https://www.youtube.com/watch?v=4PaWFYm0kEw',
    'wikipedia_the_thing': 'https://en.wikipedia.org/wiki/The_Thing_(listening_device)',
    'gyng_projects': 'https://gyng.github.io/projects/',
    
}

const TOOLS = [
    {
        'url': 'https://lapo.it/asn1js',
        'name': `ASN.1 JavaScript decoder`,
    },
    {
         'url': 'https://godbolt.org/',
         'name': `Godbolt's Compiler Explorer`,
    }
]

const PROJECTS = [
    {
        'enabled': false,
        'url': 'https://xn--9h8h.yshi.org',
        'name': 'a 4chan mirror',
    }
]

export default {
    'links': LINKS,
    'tools': TOOLS,
    'projects': PROJECTS,
}

